export default {
  goose3_duck3: 'Qingping Temp & RH Monitor / Lite',
  gd3_title: 'Qingping Temp & RH Monitor / Lite',
  gd3_first_title: 'Accurate Temperature and Humidity Measurement',
  gd3_screen: 'Screen',
  gd3_range: 'Measurement Range',
  gd3_e_ink: 'E-Ink',
  gd3_segment_lcd: 'Segmented LCD',
  gd3_temp_label: 'Temperature: ',
  gd3_humi_label: 'Humidity: ',
  gd3_screen_label: 'Screen',
  gd3_goose_screen: 'E-Ink, 50 × 50 mm',
  gd3_duck_screen: 'Segmented LCD, 50 × 50 mm',  
  gd3_five_desc:
    "Working together with Mi Home Bluetooth gateway devices, Mi Home compatible {br}devices can be triggered by Qingping Temp & RH Monitor / Qingping Temp & RH Monitor Lite to make the room more {br}comfortable automatically.",
}
